export default __webpack_public_path__ + "static/media/flourishing_bulb_petal.66e30c15.svg";